import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
import { ShieldCheck } from 'lucide-react';
export function HeroSection() {
  return <section className="bg-brand-beige py-16 md:py-24 px-6 overflow-hidden" data-id="element-115">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center gap-12" data-id="element-116">
        <div className="flex-1 text-center md:text-left" data-id="element-117">
          <FadeIn data-id="element-118">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-brand-brown leading-tight mb-6" data-id="element-119">
              Despierte Sin Ese Pinchazo en la Rodilla… En Solo 7 Días
            </h1>
          </FadeIn>
          <FadeIn delay={0.2} data-id="element-120">
            <p className="text-lg md:text-xl text-brand-dark mb-8 leading-relaxed" data-id="element-121">
              Descubra el <strong data-id="element-122">Protocolo de la Alacena</strong>: remedios
              naturales de su propia cocina que apagan la inflamación y
              devuelven la movilidad — sin pastillas que dañen su estómago.
            </p>
          </FadeIn>
          <FadeIn delay={0.4} data-id="element-123">
            <div className="flex flex-col items-center md:items-start" data-id="element-124">
              <Button onClick={() => document.getElementById('precio')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-125">
                ¡Quiero Mi Guía!
              </Button>
              <div className="flex items-center gap-2 mt-4 text-sm text-brand-brown opacity-80" data-id="element-126">
                <ShieldCheck size={16} data-id="element-127" />
                <span data-id="element-128">Descarga inmediata · Sin spam</span>
              </div>
            </div>
          </FadeIn>
        </div>
        <div className="flex-1 w-full max-w-md md:max-w-lg" data-id="element-129">
          <FadeIn delay={0.3} data-id="element-130">
            <div className="relative" data-id="element-131">
              <div className="absolute inset-0 bg-brand-brown opacity-10 rounded-3xl transform translate-x-4 translate-y-4" data-id="element-132"></div>
              <img src="https://cdn.magicpatterns.com/uploads/3ybnUWdQ2UJzDbNrbZhCf9/foto_rodillas_sin_dolor.png" alt="Portada del libro Rodillas Sin Dolor" className="relative z-10 w-full h-auto rounded-2xl shadow-2xl border-4 border-white" data-id="element-133" />
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}